import { FULL_PRODUCT_FIELDS } from './fragments/productFields';

const getPaginatedProductVariants = (
    categoryHandle,
    skintone,
    afterCursor,
    country
) => `${country ? `query @inContext(country: ${country})` : ''} {
  collection(handle: "${categoryHandle}") {
    handle
    products(first: 24 after: "${afterCursor}",
      filters: { variantMetafield: { namespace: "custom", key: "skin_tone", value: "${skintone}" } }
    ) {
      edges {
        node {
          ${FULL_PRODUCT_FIELDS({ variantShape: 'edges', variantFirst: 50 })}
        }
        cursor
      }
      pageInfo { hasNextPage }
    }
  }
}`;

export default getPaginatedProductVariants;
